import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { SummuryPipe } from '../../../Common/summury.pipe';
import { GetDataService } from '../../../services/userService/get-data.service';
import { LoaderComponent } from '../../../Common/loader/loader.component';
import { showCustomeAlert } from '../../../services/Alert/alert.service';

declare function closeAllPopovers(): void;
declare function createPopovers(): void;

@Component({
  selector: 'app-dashboard',
  imports: [CommonModule, FormsModule, RouterModule, SummuryPipe, LoaderComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  providers: [SummuryPipe]
})

export class UserDashboardComponent implements OnInit {

  popupPosition = { top: '0px', left: '0px', right: '0px' };
  popoverBody: string = "";
  data: any[] = [];
  sections: any[] = [];
  version: number = 0;

  constructor(private _route: Router, private _service: GetDataService, private _summury: SummuryPipe) { }

  ngOnInit() {
    this._service.getData().subscribe((res: any) => {     
      setTimeout(() => {
        this.data = res;
      }, 1000);
    }, (err: any) => {
      showCustomeAlert("error","Something went wrong. Please refresh the page..","Error");  
    });
  }

  onHoverIn(event: MouseEvent, item: any) {
    this.getPopups();
  }

  onCilck(section: any) {
    this.removePopups();
    this._route.navigate([`user/section/${section}`])
  }

  getSubRules(section: any) {
    if(section.subContents !== null){
    return section.subContents.map((rule: any) => `
        <div class="popover-rule-list"><div class="popover-rule-ttl"><a class='' href="user/section/${section.id}/${rule.id}">${rule.title}</a><span class='badge float-end text-bg-primary' data-toggle="tooltip" data-title="version 1.0">v${rule.version}</span></div>
        <p>${this._summury.transform(rule.content,50)}</p></div>`)
          .join("");
    }
  }
  
  getPopups() {
    createPopovers();
  }

  removePopups() {
    closeAllPopovers();
  }
}
